
 //
 // Create Base URL 'API'
 //
 

 const url ='http://api.ddtarh.ir' ;
 const version ='v1' ;
 const api ='api' ; 
 const baseURL = url + '/' + api + '/' + version + '/'

 export default {
     url, 
     version, 
     api,

     baseURL
    };
 